



















































































































import { OpportunityIcon } from '@/components/opportunities';
import { Opportunity, OpportunityMember } from '@/models/opportunities';
import { CancelationFormData, GeeksAward } from '@/models/opportunities/form-data';
import { Actions, typedStore } from '@/store';
import { computeRewardOptions, ToastsService } from '@/utils';
import Vue from 'vue';

export default Vue.extend({
  name: 'OpportunityCancelationView',
  components: {
    OpportunityIcon,
  },
  data() {
    return {
      loader: {
        isOpportunityDetailsPending: false,
      },
      form: {
        reason: '',
        geeksAward: [],
      } as CancelationFormData,
      maxRewardPercentValues: [100, 75, 50, 0],
    };
  },
  async created() {
    try {
      await this.$store.dispatch(Actions.opportunities.fetchCurrent, this.$route.params.id);
      this.opportunity.members.forEach((m: OpportunityMember) => {
        const newGeekAward: GeeksAward = {
          geekId: m.geek.id as unknown as string,
          feedback: null as unknown as string,
          gCoins: null as unknown as number,
          gxp: null as unknown as number,
        };
        (this.form.geeksAward as GeeksAward[]).push(newGeekAward);
      });
    } finally {
      this.loader.isOpportunityDetailsPending = false;
    }
  },
  computed: {
    opportunity(): Opportunity {
      return typedStore(this).state.opportunities.current;
    },
    gcoinsRewardOptions(): number[] {
      return computeRewardOptions(this.maxRewardPercentValues, this.opportunity.gCoinsAward);
    },
    gxpRewardOptions(): number[] {
      return computeRewardOptions(this.maxRewardPercentValues, this.opportunity.gxpAward);
    },
  },
  methods: {
    async checkForm() {
      const valid = await this.$validator.validate();

      if (!valid) {
        return;
      }
      this.loader.isOpportunityDetailsPending = true;
      try {
        await this.$store.dispatch(
          Actions.opportunities.cancelOngoingOpportunity,
          { opportunityId: this.opportunity.id, formData: this.form },
        );
        ToastsService.warning(this.$t('opportunities.cancelation.notifications.canceled') as string);
        this.$router.push({ name: 'opportunity-details', params: { id: this.opportunity.id } });
      } finally {
        this.loader.isOpportunityDetailsPending = false;
      }
    },
  },
});
